'use strict';

angular.module('shiftTraderApp')
    .directive('saFooterWeekBudgetArea', ['Session', function (Session) {
      return {
        templateUrl: 'views/directives/saFooterWeekBudgetArea.html',
        restrict: 'A',
        scope: {
          org: '=',
          weekData: '=saFooterWeekBudgetArea',
          weekTwix: '='
        },
        link: function (scope, elem, attrs) {
          var colorsByDepartment = ['#00b3b5', '#84ba65', '#ff9035', '#A73434', '#ACD4CC', '#E87162'];
          scope.tableDays = _.map(_.range(7), function(x) {
            return moment(scope.weekTwix.start).add(x, 'days');
          });

          var viewSelectionFromSession = Session.getMwpBudgetingSelection();
          if (viewSelectionFromSession === 'cost') {
            scope.displayMode = 'laborCost';
          } else {
            scope.displayMode = 'totalLaborHours';
          }

          scope.dayDataByDeptId = {};

          _.each(scope.org.departments, function(dept) {
            scope.dayDataByDeptId[dept.id] = {
              days: _.map(scope.weekData, function(dayData) {
                return {
                  totalLaborHours: dayData.departmentData[dept.id].totalLaborHours,
                  laborCost: dayData.departmentData[dept.id].laborCost
                };
              }),
              totalLaborHours: 0,
              laborCost: 0
            };

            _.each(['totalLaborHours', 'laborCost'], function(prop) {
              scope.dayDataByDeptId[dept.id][prop] = _.reduce(scope.dayDataByDeptId[dept.id].days, function(accum, day) {
                return accum + day[prop];
              }, 0);
            });
          });

          var calcChartData = function() {
            scope.chartData = _.map(scope.org.departments, function(dept) {
              return {
                key: dept.name,
                dept_id: dept.id,
                values: _.map(scope.dayDataByDeptId[dept.id].days, function(day, i) {
                  return [
                    scope.tableDays[i].unix() * 1000,
                    day[scope.displayMode]
                  ];
                })
              };
            });
          };

          scope.weekTotals = {
            totalLaborHours: _.reduce(scope.weekData, function(accum, day) {
              return accum + day.totalLaborHours;
            }, 0),
            laborCost: _.reduce(scope.weekData, function(accum, day) {
              return accum + day.laborCost;
            }, 0)
          };

          scope.xAxisTickFormatFunction = function(){
            return function(d, i){
              return d3.time.format('%b %e')(new Date(d));
            };
          };

          scope.yAxisTickFormatFunction = function(){
            return function(d, i){
              if (scope.displayMode === 'laborCost') {
                return '$' + d.toFixed(2);
              } else {
                return d.toFixed(2) + ' hrs';
              }
            };
          };

          scope.colorFunction = function() {
            return function(d, i) {
              return colorsByDepartment[i];
            };
          };

          scope.toggleDisplayMode = function() {
            if (scope.displayMode === 'laborCost') {
              scope.displayMode = 'totalLaborHours';
            } else {
              scope.displayMode = 'laborCost';
            }
            calcChartData();
          };

          calcChartData();
        }
      }
    }]);
